import React from 'react';
import { etapasAtivas } from '../constants';
import { EtapaStatus } from '../types';

export const ProgressSteps = ({
  etapaAtual,
  etapaCompleta,
  onStep
}: {
  etapaAtual: number;
  etapaCompleta: EtapaStatus;
  onStep: (step: number) => void;
}) => (
  <div className="progress-container">
    <div className="progress-steps">
      {etapasAtivas.map((etapa) => {
        const numero = etapa.numero;
        const complete = etapaCompleta[numero] && etapaAtual > numero;
        return (
          <button
            type="button"
            key={etapa.numero}
            className={`step ${etapaAtual === numero ? 'active' : ''} ${complete ? 'complete' : ''} ${
              numero === 8 ? 'final-step' : ''
            } ${etapaAtual < numero ? 'future' : ''}`}
            onClick={() => onStep(numero)}
          >
            <span className="step-number">{numero}</span>
            <span className="step-name">{etapa.nome}</span>
          </button>
        );
      })}
    </div>
    <div className="progress-bar">
      <div
        className="progress-fill"
        style={{
          width: `${(Math.max(0, etapasAtivas.findIndex((etapa) => etapa.numero === etapaAtual)) / (etapasAtivas.length - 1)) * 100}%`
        }}
      />
    </div>
  </div>
);
